import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
justify-content: center ;
align-items: center;
width: 80%;
flex-direction: column;

`
export const Title = styled.div`
color:#002E5C;
margin-top: 10px;
font-size: 20px;
font-weight: bolder;
line-height: 32px;
`
export const Content = styled.div`
min-height: 350px;
margin-bottom: 40px;
`